<div
  class="box has-advanced-upload"
  [style.width]="boxWidth"
  [style.height]="boxHeight"
  [class.on_drag-over]="dragOver"
  [class.error]="error"
  (dragenter)="drag($event)"
  (dragover)="$event.preventDefault(); dragOver = true"
  (dragleave)="dragOver = false"
  (drop)="onDrop($event)"
  (click)="file.click()"
>
  <div class="box__input">
    <ng-container *ngIf="video === undefined; else videoHolder">
      <div class="d-flex flex-column gap-3 justify-content-center align-items-center">
        <i class="fas fa-3x fa-image"></i>
        <h5>{{ title }}</h5>
        <p>{{ description }}</p>
      </div>
    </ng-container>
    <ng-template #videoHolder>
      <div class="box__image">
        <video [src]="video" alt="user video"></video>
      </div>
    </ng-template>
    <input
      type="file"
      (change)="getFile($event)"
      name="files"
      id="file"
      [accept]="fileType.join(',')"
      class="box__file"
      #file
    />
  </div>
</div>
